import { QRCodeSVG } from "qrcode.react";
import { Smartphone } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const STEPS = [
  "Open the Google Messages app on your phone",
  "Tap your profile photo → Device pairing",
  "Tap QR code scanner and scan this code",
];

export const QrDialog = ({ open, qrUrl, onClose }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-md" data-testid="sms-qr-dialog">
      <DialogHeader>
        <DialogTitle className="font-['Outfit'] flex items-center gap-2">
          <Smartphone className="w-5 h-5 text-[#385C4B]" /> Connect your phone
        </DialogTitle>
      </DialogHeader>
      <div className="flex flex-col items-center gap-4 py-2">
        <div className="p-4 bg-white rounded-xl border border-[#E0DFD6] shadow-sm" data-testid="sms-qr-code">
          {qrUrl ? <QRCodeSVG value={qrUrl} size={240} level="M" /> : <div className="w-[240px] h-[240px] animate-pulse bg-[#EFEEE6] rounded" />}
        </div>
        <ol className="text-sm text-[#3A3A35] space-y-1.5 self-stretch">
          {STEPS.map((s, i) => (
            <li key={s} className="flex gap-2">
              <span className="w-5 h-5 shrink-0 rounded-full bg-[#385C4B] text-white text-[11px] grid place-items-center font-semibold">{i + 1}</span>
              {s}
            </li>
          ))}
        </ol>
        <p className="text-[11px] text-[#6B6B61] text-center">
          QR har 30 second me badalta hai. Scan hote hi ye window band ho jayegi.
        </p>
        <button onClick={onClose} data-testid="sms-qr-cancel"
          className="h-9 px-4 rounded-full border border-[#E0DFD6] text-sm text-[#3A3A35] hover:bg-[#EFEEE6] transition-colors">
          Cancel
        </button>
      </div>
    </DialogContent>
  </Dialog>
);
